import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DateUtilService, S3UploadService, GungNotificationService } from 'gung-common';
import {
  ActivityInternalCreateModalComponent,
  ActivityInternalService,
  AuthService,
  CustomerContact,
  CustomerContactService,
  CustomerService,
  GungModalService,
  MetadataService,
  SelectedCustomerService,
  ActivityInternalCustomerResponsibleService
} from 'gung-standard';
import { JeevesModalService } from 'gung-standard-jeeves';

@Component({
    selector: 'colmec-activity-internal-create-modal',
    templateUrl: './colmec-activity-internal-create-modal.component.html',
    styleUrls: ['./colmec-activity-internal-create-modal.component.scss'],
    standalone: false
})
export class ColmecActivityInternalCreateModalComponent extends ActivityInternalCreateModalComponent implements OnInit {
  protected contactsCustomer: CustomerContact[];

  contactEmailField = (contact: CustomerContact) => contact?.extra?.CS8?.comnr;

  public modelSearch: any;
  formatter = (item: CustomerContact) => this.contactEmailField(item);
  resultFormatter = (item: CustomerContact) => item.name + ' - ' + this.contactEmailField(item);

  minDate = new Date();
  minDatePickerDate: NgbDateStruct = this.dateUtilService.createNgbDateFromDate(this.minDate);

  constructor(
    protected formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    protected activityInternalService: ActivityInternalService,
    protected authService: AuthService,
    protected selectedCustomerService: SelectedCustomerService,
    protected customerContactService: CustomerContactService,
    protected jeevesModalService: JeevesModalService,
    protected metadataService: MetadataService,
    protected gungModalService: GungModalService,
    protected customerService: CustomerService,
    dateUtilService: DateUtilService,
    protected s3UploadService: S3UploadService,
    protected activityInternalCustomerResponsibleService: ActivityInternalCustomerResponsibleService,
    protected gungNotificationService: GungNotificationService
  ) {
    super(
      formBuilder,
      activeModal,
      activityInternalService,
      authService,
      selectedCustomerService,
      metadataService,
      customerContactService,
      customerService,
      dateUtilService,
      s3UploadService,
      activityInternalCustomerResponsibleService,
      gungNotificationService
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  addContact() {
    this.jeevesModalService.openAddContactModalAsPromise(this.currentCustomer).then(
      (result: CustomerContact[]) => {
        const inputItem: FormArray = this.submitForm.get('contacts') as FormArray;
        inputItem.push(this.formBuilder.control({ value: this.contactEmailField(result[0]), disabled: true }));
      },
      reason => {}
    );
  }
}
